module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADqSURBVHgBxVLRDYIwEL0WBmAD6waMIBMIhAWcQJ2AEXQDcQHKBsgE4gaMgAMAvottwocC8ceXHKXNvbte3xM0QhiGHhaPPqMtiqK1G2EIynGcyzAMPid8ISohxK3ruh0KNC6fSClLHGQ4CGgCaJCCXOJ3LZIk2YCUaq0nSRZxHN/7vj9KfPgKDS1HjbFWkn7EH4iYsYEMaikB76GYwx1rbPwoirZzJFaAHxMKVNYAPrTU9Bb/muf52ZjiRMZJuJVnIoLetRhXhEYpFoV4IPaonrFbDPHJBJvrjolIrND5wDMjArYWLYUx+ixeh2dxF7u85VMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f2.png
// module id = fcwo
// module chunks = 1